import React, {FunctionComponent} from 'react';
import HanTable, {HanTableCell, HanTableContainer, HanTableRow} from '../../../utils/han-table-components/HanTable';
import {SubjectArea} from '../../../../networking/repos/SubjectAreaRepository';
import {Link} from 'react-router-dom';
import {route} from 'b302-frontend-library';
import SortableTableHead, {SortableTableHeadCell} from '../SortableTableHead';
import { highlightSearchMatches } from '../../../utils/SearchUtils';


interface Props {
    subjectAreas: SubjectArea[];
    onOrderBy: (column: string, direction?: string) => void;
    orientation?: 'vertical' | 'horizontal';
    searchQuery?: string;
}

const SubjectAreasTable: FunctionComponent<Props> = React.memo(({ searchQuery, subjectAreas, onOrderBy, orientation = 'horizontal' }) => {
    const subjectTableHeadCells: SortableTableHeadCell[] = [
        {
            name: 'Subject',
            orderByName: 'name',
        },
        {
            name: 'University',
            orderByName: 'university',
        },
        {
            name: 'Level',
            orderByName: 'course_level',
        },
        {
            name: 'Language',
            orderByName: 'language',
        },
        {
            name: 'ECTS',
            orderByName: 'ects',
        },
        {
            name: 'Code',
            orderByName: 'code',
        },
        {
            name: 'Program student',
            orderByName: 'program_student'
        }
    ];

    return (
        <HanTableContainer>
            <HanTable borderOrientation={orientation} className={'subject-areas-page__table'}>
                <SortableTableHead cells={subjectTableHeadCells} onOrderBy={onOrderBy}></SortableTableHead>
                
                { subjectAreas.map(subject => (
                    <HanTableRow key={subject.id}>
                        <HanTableCell modifiers={['alabaster']}>
                            <span dangerouslySetInnerHTML={{ __html: highlightSearchMatches(subject.name, searchQuery)}}></span>
                        </HanTableCell>
                        <HanTableCell>
                            <Link to={route('university-detail', [subject.university?.id])}>
                                { subject.university?.name || 'Not found' }
                            </Link>
                        </HanTableCell>
                        <HanTableCell modifiers={['alabaster']}>{ subject.course_level || 'Not found' }</HanTableCell>
                        <HanTableCell>{ subject.language || 'Not found' }</HanTableCell>
                        <HanTableCell modifiers={['alabaster']}>{ subject.ects || 'Not found' }</HanTableCell>
                        <HanTableCell>{ subject.code || 'Not found' }</HanTableCell>
                        <HanTableCell modifiers={['alabaster']}>{ subject.program_student || 'Not found' }</HanTableCell>
                    </HanTableRow>
                )) }
            </HanTable>
        </HanTableContainer>
    );
});

export default SubjectAreasTable;
